//component for images display
const Lightbox = Vue.component('lightbox', {
    template: `
    <div id="lightbox" v-if="visible" @click.self="close">

        <!-- images -->
        <div class="img-container" :style="imgStyle">
            <img :src="imgs[imgIndex]" draggable="false" @mousedown="handleMouseDown($event)" @mouseup="handleMouseUp($event)" @mousemove="handleMouseMove($event)">
        </div>

        <!-- buttons -->
        <div class="buttons-container">
            <div class="btn-prev" @click="prev">
                <i class="fas fa-chevron-left"></i>
            </div>
            <div class="btn-next" @click="next">
                <i class="fas fa-chevron-right"></i>
            </div>
            <div class="btn-close" @click="close">
                <i class="fas fa-times"></i>
            </div>
            <div class="tools">
                <div class="tool-btn btn-in" @click="zoomIn">
                    <i class="fas fa-search-plus"></i>
                </div>
                <div class="tool-btn btn-out" @click="zoomOut">
                    <i class="fas fa-search-minus"></i>
                </div>
                <div class="tool-btn btn-rotate" @click="rotate">
                    <i class="fas fa-redo"></i>
                </div>
            </div>
        </div>

        <!-- total -->
        <div class="total">
            {{ imgIndex + 1 }}/{{ imgs.length }}
        </div>
    </div>
    `,

    name: 'lightbox',

    props: {
        'visible': Boolean,
        'index': Number,
        'imgs': Array
    },
    data() {
        return {
            imgIndex: 0,
            scale: 1,
            rotateDeg: 0,
            top: 0,
            left: 0,
            isDraging: false,
            imgTransitionStatus: true,
            lastX: 0,
            lastY: 0,
            doTransition: true
        };
    },
    computed: {
        imgStyle() {
            if (this.doTransition) {
                return {
                    transform: `translate(-50%, -50%)
                       scale(${this.scale})
                       rotate(${this.rotateDeg}deg)`,
                    top: `calc(50% + ${this.top}px)`,
                    left: `calc(50% + ${this.left}px)`,
                    transition: `transform 0.3s ease-in-out`
                }
            } else {
                return {
                    transform: `translate(-50%, -50%)
                       scale(${this.scale})
                       rotate(${this.rotateDeg}deg)`,
                    top: `calc(50% + ${this.top}px)`,
                    left: `calc(50% + ${this.left}px)`
                }
            }
        }
    },
    watch: {
        visible(visible) {
            if (visible === true) {
                this.init()
            }
        }
    },
    methods: {
        init() {
            this.imgIndex = this.index
            this.scale = 1
            this.rotateDeg = 0
            this.top = 0
            this.left = 0
            this.isDraging = false
        },
        prev() {
            if (this.imgIndex !== 0) {
                this.imgIndex -= 1;
                this.resetPosition()
            }
        },
        next() {
            if (this.imgIndex !== this.imgs.length - 1) {
                this.imgIndex += 1;
                this.resetPosition()
            }
        },
        rotate() {
            this.rotateDeg += 90;
        },
        zoomOut() {
            if (this.scale !== 0) {
                this.scale -= .25;
            }
        },
        zoomIn() {
            this.scale += 0.25
        },
        resetPosition() {
            this.doTransition = false;
            this.scale = 1
            this.rotateDeg = 0
            setTimeout(() => {
                this.doTransition = true;
            }, 10);
        },
        close() {
            this.$emit('hide');
        },
        handleMouseDown(e) {
            if (!this.checkBtn(e.button)) return
            this.lastX = e.clientX
            this.lastY = e.clientY
            this.isDraging = true
            e.stopPropagation()
        },
        handleMouseUp(e) {
            if (!this.checkBtn(e.button)) return
            this.isDraging = false
            this.lastX = this.lastY = 0
        },
        handleMouseMove(e) {
            if (!this.checkBtn(e.button)) return
            if (this.isDraging) {
                this.top = this.top - this.lastY + e.clientY
                this.left = this.left - this.lastX + e.clientX
                this.lastX = e.clientX
                this.lastY = e.clientY
            }
            e.stopPropagation()
        },
        checkBtn(btn) {
            if (btn === 0) return true
            return false
        },
    }
});
